module.exports = __webpack_public_path__ + "img/widget_004.38f8db96.png";